import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiError, setArea } from "@/lib/api";
import { Eye, Loader2, Undo2 } from "lucide-react";
import { toast } from "sonner";

/** Sai da conta da pessoa e volta para a tela do admin de onde ele saiu (lista ou ficha). */
export async function stopImpersonation(setUser, navigate) {
  try {
    const r = await api.post("/auth/stop-impersonation");
    setArea("prof");
    setUser(r.data);
    let dest = "/admin/alunos";
    try { dest = sessionStorage.getItem("iep-imp-return") || dest; sessionStorage.removeItem("iep-imp-return"); } catch (e) { /* sem sessionStorage */ }
    navigate(dest.startsWith("/admin") ? dest : "/admin/alunos", { replace: true });
    toast.success("De volta à área administrativa.");
    return true;
  } catch (e) {
    toast.error(formatApiError(e.response?.data?.detail));
    if (e.response?.data?.relogin) {        // caminho de volta expirou: vai para o login do admin
      setUser(false);
      navigate("/login", { replace: true });
    }
    return false;
  }
}

/** Faixa fixa quando o admin está dentro da conta de um aluno/professor. */
export const ImpersonationBanner = () => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!user?.impersonator) return null;

  const back = async () => {
    setBusy(true);
    await stopImpersonation(setUser, navigate);
    setBusy(false);
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-3xl flex items-center justify-center gap-3 flex-wrap px-4 py-2.5 rounded-xl shadow-2xl text-sm text-white" style={{ background: "#B45309" }} data-testid="impersonation-banner">
      <Eye className="h-4 w-4" />
      <span>Você está vendo a plataforma como <strong>{user.name}</strong> ({user.email}).</span>
      {user.contract_preview && (
        <button onClick={() => navigate("/assinatura-previa")} className="inline-flex items-center gap-1.5 rounded-md bg-white/15 border border-white/40 font-semibold px-3 py-1 hover:bg-white/25" data-testid="contract-preview-link">
          Ver tela de assinatura (prévia)
        </button>
      )}
      <button onClick={back} disabled={busy} className="inline-flex items-center gap-1.5 rounded-md bg-white text-[#B45309] font-semibold px-3 py-1 hover:bg-amber-50" data-testid="stop-impersonation">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Undo2 className="h-4 w-4" />} Voltar para o admin
      </button>
    </div>
  );
};

/** Entrar na conta (usado nas listas e na página do aluno/professor). */
export async function impersonate(kind, id, setUser, navigate) {
  try {
    try { sessionStorage.setItem("iep-imp-return", window.location.pathname); } catch (e) { /* segue sem lembrar a tela */ }
    const r = await api.post(`/admin/impersonate/${kind}/${id}`);
    if (kind === "aluno" && r.data.role === "instructor") {
      // professora que também é aluna: entra na área do aluno do mesmo login (o servidor lê o cookie da área)
      setArea("aluno");
      window.location.assign("/app");
      return;
    }
    setArea("prof");
    setUser(r.data);
    navigate(r.data.role === "instructor" ? "/prof" : "/app", { replace: true });
    toast.success(`Acessando como ${r.data.name}.`);
  } catch (e) {
    toast.error(formatApiError(e.response?.data?.detail));
  }
}
